import { getAxiosInstance } from '../api.client';
import { type ProfitWarning } from './profitWarnings.models';

export async function getProfitWarnings(
    projectId: string,
): Promise<ProfitWarning[]> {
    const response = await getAxiosInstance().get<ProfitWarning[]>(
        `/project/${projectId}/profit-warnings`,
    );

    return response.data;
}
